import { sectors } from 'client/store/layersSlice/layersSlice';
import { setAnnotationsShowing, setCustomBackdropShowing, setDeclutterCustomVectors, setDimensionsShowing, setHideBasemap } from 'client/store/mapSlice/mapSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_OWNER_STATE, selectOwnerState, setOwnerPreference } from 'client/store/isolatedViewsSlice/isolatedViewsSlice';

export const syncOwnerPreferencesToMap = (dispatch, ownerState = DEFAULT_OWNER_STATE) => {
    dispatch(setAnnotationsShowing(Boolean(ownerState?.descriptions)));
    dispatch(setDimensionsShowing(Boolean(ownerState?.dimensions)));
    dispatch(setDeclutterCustomVectors(Boolean(ownerState?.overlapping)));
    dispatch(setHideBasemap(!ownerState?.standardMap));
    dispatch(setCustomBackdropShowing(Boolean(ownerState?.customMap)));
};

// Hook to get the sector symbology state and toggle for a specific owner.
export const useOwnerSectorSymbology = (ownerId) => {
    const dispatch = useDispatch();
    const currentState = useSelector(state => selectOwnerState(state, ownerId));
    const sectorSymbology = {
        [sectors.ELECTRICITY]: currentState[sectors.ELECTRICITY],
        [sectors.GAS]: currentState[sectors.GAS]
    };

    const toggleSector = (sector) => {
        const newValue = !sectorSymbology[sector];
        dispatch(setOwnerPreference({ ownerId, key: sector, value: newValue }));
    };

    return { sectorSymbology, toggleSector };
};

// Hook to get the checkbox state for a specific owner.
export const useOwnerPreferenceCheckboxes = (ownerId) => {
    const dispatch = useDispatch();
    const currentState = useSelector(state => selectOwnerState(state, ownerId));
    const checkboxes = {
        descriptions: currentState.descriptions,
        dimensions: currentState.dimensions,
        overlapping: currentState.overlapping,
        standardMap: currentState.standardMap,
        customMap: currentState.customMap
    };

    const handleCheckboxChange = (boxName) => {
        const newValue = !checkboxes[boxName];
        const nextOwnerState = {
            ...currentState,
            [boxName]: newValue
        };

        dispatch(setOwnerPreference({ ownerId, key: boxName, value: newValue }));
        syncOwnerPreferencesToMap(dispatch, nextOwnerState);
    };

    return { checkboxes, handleCheckboxChange };
};

export default {
    useOwnerSectorSymbology,
    useOwnerPreferenceCheckboxes
};
